// ============================================================
// Braval - Auction Form (shared by Edit and New)
// ============================================================

import React, { useState, useEffect } from 'react';

const EMPTY = {
    project_name:    '',
    auction_date:    '',
    auctioneer_firm: '',
    location_region: '',
    buyers_premium:  '',
    sales_tax:       '',
    data_source:     '',
};

export default function AuctionForm({ initialValues, onSave, isSaving, saveError, pageTitle, onBack, onDelete, toolbar }) {
    const [form, setForm] = useState({ ...EMPTY, ...initialValues });

    useEffect(() => {
        setForm({ ...EMPTY, ...initialValues });
    }, [initialValues]);

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(form);
    };

    // auction_date from DB comes as ISO datetime; slice to YYYY-MM-DD for date input
    const dateValue = form.auction_date ? String(form.auction_date).slice(0, 10) : '';

    return (
        <form className="lot-form" onSubmit={handleSubmit}>
            <div className="lot-form-header">
                <h2 className="lot-form-title">{pageTitle}</h2>
                {toolbar && <div className="lot-form-toolbar">{toolbar}</div>}
            </div>

            <div className="lot-form-grid">

                {/* Project Name */}
                <div className="filter-group lot-form-full">
                    <label className="filter-label">Project Name *</label>
                    <input
                        type="text"
                        className="filter-input"
                        value={form.project_name}
                        onChange={(e) => handleChange('project_name', e.target.value)}
                        required
                    />
                </div>

                {/* Auction Date */}
                <div className="filter-group">
                    <label className="filter-label">Auction Date</label>
                    <input
                        type="date"
                        className="filter-input"
                        value={dateValue}
                        onChange={(e) => handleChange('auction_date', e.target.value)}
                    />
                </div>

                {/* Auctioneer */}
                <div className="filter-group">
                    <label className="filter-label">Auctioneer</label>
                    <input
                        type="text"
                        className="filter-input"
                        value={form.auctioneer_firm}
                        onChange={(e) => handleChange('auctioneer_firm', e.target.value)}
                    />
                </div>

                {/* Location */}
                <div className="filter-group">
                    <label className="filter-label">Location / Region</label>
                    <input
                        type="text"
                        className="filter-input"
                        value={form.location_region}
                        onChange={(e) => handleChange('location_region', e.target.value)}
                    />
                </div>

                {/* Data Source */}
                <div className="filter-group">
                    <label className="filter-label">Data Source</label>
                    <select
                        className="filter-input"
                        value={form.data_source}
                        onChange={(e) => handleChange('data_source', e.target.value)}
                    >
                        <option value="">— Select —</option>
                        <option value="Comps-Classic">Comps-Classic</option>
                        <option value="Observed">Observed</option>
                        <option value="TBG Bidspotter">TBG Bidspotter</option>
                        <option value="TBG Classic">TBG Classic</option>
                    </select>
                </div>

                {/* Buyer's Premium */}
                <div className="filter-group">
                    <label className="filter-label">Buyer's Premium (%)</label>
                    <input
                        type="number"
                        className="filter-input"
                        value={form.buyers_premium}
                        onChange={(e) => handleChange('buyers_premium', e.target.value)}
                        min="0"
                        max="100"
                        step="0.01"
                        placeholder="e.g. 15.00"
                    />
                </div>

                {/* Sales Tax */}
                <div className="filter-group">
                    <label className="filter-label">Sales Tax (%)</label>
                    <input
                        type="number"
                        className="filter-input"
                        value={form.sales_tax}
                        onChange={(e) => handleChange('sales_tax', e.target.value)}
                        min="0"
                        max="100"
                        step="0.01"
                        placeholder="e.g. 6.50"
                    />
                </div>

            </div>

            {saveError && (
                <div className="lot-form-error">{saveError}</div>
            )}

            <div className="lot-form-actions">
                <div className="lot-form-actions-left">
                    <button type="submit" className="search-button" disabled={isSaving}>
                        {isSaving ? 'Saving...' : 'Save'}
                    </button>
                    {onBack && (
                        <button type="button" onClick={onBack} className="search-button auction-back-button">Cancel</button>
                    )}
                </div>
                {onDelete && (
                    <button type="button" onClick={onDelete} className="search-button delete-button">Delete Auction</button>
                )}
            </div>
        </form>
    );
}
